export enum BLOCK_NAME {
    SERVICE = 'service',
    WORK = 'work',
    CLIENTS = 'clients',
    PROJECT = 'project',
}
